module.exports = __webpack_public_path__ + "img/undraw_performance_overview_p9bm.ac1714cd.svg";